export default __webpack_public_path__ + "static/media/logo-platzi-video-BW2.435b1bef.png";